import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManageRoleGroupsPage } from './manage-role-groups.page';

const routes: Routes = [
  {
    path: '',
    component: ManageRoleGroupsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageRoleGroupsPageRoutingModule {}
